import { CheckoutFeedbackProjection } from "../../../projection/checkoutFeedback/checkoutFeedback";

const checkoutFeedback: CheckoutFeedbackProjection = {
  ["efe07b97-f6fb-4b6a-ba92-b68519320b2c"]: "68c0bb98-b00a-4b86-af43-528fe903cb69",
  ["6a6d3878-5561-412c-96f3-7ed79ee587bb"]: "7970edd3-fb5c-42d3-afe3-ce31bcbb856c",
};

export { checkoutFeedback };
